import { render, staticRenderFns } from "./record_content.vue?vue&type=template&id=40a6ad08"
import script from "./record_content.vue?vue&type=script&lang=js"
export * from "./record_content.vue?vue&type=script&lang=js"
import style0 from "./record_content.vue?vue&type=style&index=0&id=40a6ad08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports